import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EditableTextViewComponent } from './text.view.div.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    EditableTextViewComponent,
  ],
  exports: [
    EditableTextViewComponent,
  ],
})
export class TextEditingModule { }
